import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/stack/stack.js'

const tagName = 'dap-ds-stack'

/**
 * `dap-ds-stack`
 * @summary A stack is a container for stacked content.
 * @element dap-ds-stack
 * @title - Stack
 *
 * @slot - The content of the stack.
 *
 * @csspart stack - The main stack container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSStack',
})

export default reactWrapper
